export default [
    {
        path: 'escolher-veiculo',
        component: () => import(
            '@/views/transporte-paciente/escolher/Index'
        ),
        redirect: 'escolher-veiculo/create',
        children: [
            {
                name: 'transporte-paciente-escolher-veiculo-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/escolher/List'
                ),
            },
        ],
    },
]